export default __webpack_public_path__ + "static/media/carpediembes6.4cd54e90.jpg";